import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { INewsItem } from "./models";

export const NewsListApi = async () => {
  const { data } = await api.post<INewsItem[]>(
    API_ROUTES.NEWS_LIST,
    qs.stringify({
      ...defaultOptions(),
    })
  );

  return data;
};
